export const useDescribedBy=ids=>{const filteredIds=ids.filter(Boolean);return filteredIds.length?filteredIds.join(" "):void 0};